import React, { useEffect, useState } from "react";

import { Card } from "react-bootstrap";
import { AiOutlineStar, AiTwotoneStar } from "react-icons/ai";
import { useNavigate } from "react-router";
import { useUserData } from "../../hooks/UserContext";
import PriceProduct from "../../components/PriceProduct";
import api from "../../_services/api";
import { LinkImage, Container, Button, Down } from "./styles";
import { useApp } from "../../contexts/AppContext";
import { clientesApi } from "../../page/OrderResumePag/_services/api";
import notify from "../UI/toast";

const CardProduct = (product) => {
  const [enterJWT, setEnterJWT] = useState(false);
  const [dataUser, setDataUser] = useState();
  const [wishlist, setWishList] = useState(product.wishlist);
  const { whitelabel } = useApp();
  const [displayMode, setDisplayMode] = useState(whitelabel?.payment_mode);

  useEffect(() => {
    setDisplayMode(whitelabel?.payment_mode);
  }, [whitelabel]);

  const navigate = useNavigate();

  function RoutesProduct(id) {
    if (product.onProductClick) {
      product.onProductClick(id);
    }
    navigate("/loja/product/" + id);
  }

  const jwt = useUserData();
  if (jwt.userData?.data && !enterJWT) {
    setEnterJWT(() => true);
    setDataUser(jwt.userData.data);
  }

  async function handleFavoriteProduct(uuid) {
    try {
      if (wishlist) {
        await clientesApi.delete(
          "/customer/" + dataUser?.cpf + "/wishlist/product/" + uuid
        );
        setWishList(false);
        notify("Produto removido dos favoritos", "success");
        
        if (product.onWishlistRemoved) {
          product.onWishlistRemoved(uuid);
        }
      } else {
        await clientesApi.post(
          "/customer/" + dataUser?.cpf + "/wishlist",
          {
            product_uuid: uuid,
            customer_uuid: dataUser?.uuid,
          }
        );
        setWishList(true);
        notify("Produto adicionado aos favoritos", "success");
        if (product.onAddToWishlist) {
          product.onAddToWishlist(uuid);
        }
      }
    } catch (e) {
      console.log("erro", e);
    }
  }

  useEffect(() => {
    setWishList(product.wishlist);
    if (jwt.userData?.data) {
      const fetchData = async () => {
        setWishList(product.wishlist);
      };
      fetchData();
    }
  }, []);

  return (
    <Container>
      <Card className="card-product">
        {wishlist ? (
          <AiTwotoneStar
            className="product-favorite-star"
            style={{ color: whitelabel?.button_primary_color, cursor: "pointer" }}
            onClick={() => handleFavoriteProduct(product.id)}
          />
        ) : (
          <AiOutlineStar
            className="product-favorite-star"
            style={{ color: whitelabel?.button_primary_color, cursor: "pointer" }}
            onClick={() => handleFavoriteProduct(product.id)}
          />
        )}
        <Card.Body className="card-body-product">
          <LinkImage
            img={product.image}
            alt={product.label}
            onClick={() => RoutesProduct(product.id)}
            className="position-relative"
          >
            {product.cashback && parseFloat(product.cashback) > 0 && (
              <div
                className="mb-1 py-1 bg-primary d-flex justify-content-center align-items-center position-absolute w-100"
                style={{ bottom: "-1.2rem" }}
              >
                <span className="color fw-bold text-white text-xs">
                  {`Ganhe ${parseFloat(product.cashback)}% de Cashback`}
                </span>
              </div>
            )}
          </LinkImage>
          <Card.Title
            onClick={() => RoutesProduct(product.id)}
            className="title-product font-wl-400 px-03"
          >
            {product.label.slice(0, 25)}
            {product.label.length > 25 && "..."}
          </Card.Title>
          <PriceProduct price={product.price} displayMode={displayMode}/>
          <Down>
            <Button
              className="font-wl-600"
              style={{ fontSize: "10px" }}
              variant="light"
              onClick={() => RoutesProduct(product.id)}
              color={whitelabel?.button_primary_color}
            >
              COMPRAR
            </Button>
          </Down>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CardProduct;
